import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";

const StaffProfileApprovalForm = ({
  userInfoData,
  rowData,
  callFunction,
  onCloseModal,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    description: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  const validateForm = (formValues, isReject) => {
    let errors = {};

    if (!formValues.description && isReject) {
      errors.description = "required!";
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    const method = "PUT";
    const endpoint = "/user/approve-or-reject-staff-profile-approval";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (isReject) => {
    const errors = validateForm(formValues, isReject);
    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      const userData = {
        uid: rowData?.uid || "",
        status: isReject ? "rejected" : "approved",
        remarks: formValues.description || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);

        onCloseModal();
      };

      showConfirmAlert(
        handleConfirm,
        "Are you sure you want to approve this profile picture?",
        "No, Cancel",
        "Yes, Submit"
      );
    }
  };

  return (
    <form className="formContainer mb15">
      <div className="formInputsGrid twoGridSystem">
        <div className="formInputBox image-box span2">
          <img
            src={rowData?.profile}
            alt={rowData?.name || "NA"}
            className="image"
          />
        </div>

        <div className="formInputBox span2">
          <label htmlFor="description" className="formInputLabel">
            Enter remarks{" "}
            {formErrors.description ? (
              <span className="required">*</span>
            ) : null}
          </label>

          <textarea
            name="description"
            className={`formInput ${formErrors.description ? "formError" : ""}`}
            style={{
              background: "#fff",
              minHeight: "150px",
            }}
            placeholder="Enter Remarks"
            value={formValues.description || ""}
            onChange={(e) =>
              setFormValues((prevs) => ({
                ...prevs,
                description: e.target.value,
              }))
            }
          ></textarea>
        </div>
      </div>

      <CloseSubmitBtn
        submitLabel={"Approve Profile Picture"}
        closeLabel="Reject Profile Picture"
        onSubmit={() => onSubmit(false)}
        onClose={() => onSubmit(true)}
        isLoading={postPutLoading}
      />
    </form>
  );
};

export default StaffProfileApprovalForm;
